module.exports = __webpack_public_path__ + "img/mountedcrane_stopped.85f459a6.svg";